// extracted by mini-css-extract-plugin
export var circle = "_48-2";
export var icon = "_48-a";
export var iconHighlight = "_48-0";
export var lg = "_48-8";
export var md = "_48-7";
export var outline = "_48-4";
export var sm = "_48-6";
export var square = "_48-1";
export var xl = "_48-9";
export var xs = "_48-5";
export var xxs = "_48-3";